




















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-button-info',
})
export default class ButtonInfo extends Vue {
  @Prop({ type: String, default: 'primary' }) readonly mainButtonVariant: string;
  @Prop({ type: String, default: 'm-1' }) readonly buttonGroupClass: string;
  @Prop({ type: String }) readonly mainButtonLabel: string;
  @Prop({ type: String, default: 'primary' }) readonly infoButtonVariant: string;
  @Prop({ type: String }) readonly infoText: string;
  @Prop({ type: Boolean, default: false }) readonly showInfo: boolean;

  showExtraInfo = false;

  mounted() {
    this.showExtraInfo = this.showInfo;
  }

  clickOnMainButton() {
    this.$emit('click');
  }

  @Watch('showInfo')
  onShowInfoChanged(value: boolean) {
    this.showExtraInfo = value;
  }
}
